import React from 'react';
import classNames from 'classnames/bind';

import HighlightContainer from 'components/HighlightArea/HighlightContainer';
import { Button } from '@thinkific/toga-react';
import { MentionedUsersFieldFragment } from '__generated__/graphql/legacy/graphql';

import { TFunction } from 'next-i18next';
import AttachmentDisplayer from 'components/AttachmentDisplayer';
import { Attachment } from 'schema/Post/types';
import styles from '../Post.module.scss';

const cx = classNames.bind(styles);

interface ExpandableContentProps {
  shouldClampContent: boolean;
  setShouldClampContent: (shouldClamp: boolean) => void;
  postToScrollToOffset?: number;
  content: string;
  hasAttachment: boolean;
  attachments?: Attachment[];
  shouldScroll: boolean;
  mentionedUsers?: MentionedUsersFieldFragment | null;
  isReplyPanel?: boolean;
  t: TFunction;
  isComment?: boolean;
}

const ExpandableContent = ({
  shouldClampContent,
  postToScrollToOffset,
  setShouldClampContent,
  content,
  hasAttachment,
  attachments,
  mentionedUsers,
  isReplyPanel,
  shouldScroll,
  t,
  isComment,
}: ExpandableContentProps) => {
  const handleExpandCollapse = (e: Event) => {
    if (!shouldClampContent && shouldScroll) {
      window.scrollTo(0, postToScrollToOffset || 0);
    }

    e.preventDefault();
    e.stopPropagation();
    setShouldClampContent(!shouldClampContent);
  };

  const readContentButton = content.length > 160 && (
    <Button
      appearance="accessible-link"
      className={cx('post__content--button')}
      data-qa="read-post__button"
      onClick={handleExpandCollapse}
    >
      {shouldClampContent ? t('Read more') : t('Read less')}
    </Button>
  );

  return (
    <span
      className={cx(
        'post__content',
        hasAttachment ? 'post__content--attachment' : ''
      )}
      data-qa="post__content"
    >
      <div
        className={cx(
          'post__content__text',
          shouldClampContent ? 'post__content__text--clamped' : ''
        )}
      >
        <HighlightContainer content={content} mentionedUsers={mentionedUsers} />
      </div>
      {readContentButton}
      {hasAttachment && (
        <AttachmentDisplayer
          attachments={attachments || []}
          isComment={isComment}
          isReplyPanel={isReplyPanel}
          t={t}
        />
      )}
    </span>
  );
};

export default ExpandableContent;
